/// <amd-module name="Wiki/Editor/WikiEditorService" />
import { Services, VssService } from "VSS/Platform/Context";

import { WikiPage, WikiType } from "Wiki/Clients/Wiki/Contracts/Wiki";
import { IWikiEditorFlux, IWikiEditorService } from "Wiki/Editor/Contracts";
import { EditorActionCreator } from "Wiki/Editor/WikiEditorActionCreator";
import { EditorActions, EditorStore, registerActionsWithStores } from "Wiki/Editor/WikiEditorStore";
import { ActionListener } from "Wiki/ViewCommon/ActionListener";
import { IEditorLegacyModules } from "Wiki/ViewCommon/Contracts";

export class WikiEditorService extends VssService implements IWikiEditorService {
    public setupFlux(
        closeEditor: () => void,
        initialText: string,
        updateSavedPage: (page: WikiPage, pageVersion: string) => void,
        initialName: string,
        legacyScripts: IEditorLegacyModules,
        wikiType: WikiType,
        hideCloseButton?: boolean
    ): IWikiEditorFlux {
        const actionListener = new ActionListener();
        const editorActions = new EditorActions();
        const store = new EditorStore("EditorStore", initialName, legacyScripts, hideCloseButton);
        registerActionsWithStores(actionListener, editorActions, store);
        const actionCreator = new EditorActionCreator(
            closeEditor,
            editorActions,
            () => store.getState(),
            this.pageContext,
            wikiType,
            updateSavedPage
        );

        return {
            actionCreator,
            store,
            removeActionListeners: () => actionListener.removeListeners()
        };
    }
}

Services.add("wiki-editor-service", { serviceFactory: WikiEditorService });
